import { render, staticRenderFns } from "./palRisk.vue?vue&type=template&id=29f1bd3e&scoped=true&"
import script from "./palRisk.vue?vue&type=script&lang=js&"
export * from "./palRisk.vue?vue&type=script&lang=js&"
import style0 from "./palRisk.vue?vue&type=style&index=0&id=29f1bd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1bd3e",
  null
  
)

export default component.exports